import React from 'react';

var ColBodyInnerBottomWr = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'bottom-inside-inner-wrapper' }, children);
};

export { ColBodyInnerBottomWr };
